import API from "../config/api";

function getToken() {
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("ecovanta_token") ||
    ""
  );
}

function getAuthHeaders() {
  const token = getToken();

  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function request(path, options = {}) {
  const response = await fetch(`${API}${path}`, {
    ...options,
    credentials: "include",
    headers: {
      ...getAuthHeaders(),
      ...(options.headers || {}),
    },
  });

  const contentType = response.headers.get("content-type") || "";
  const raw = await response.text();

  let data = {};

  if (raw && contentType.includes("application/json")) {
    try {
      data = JSON.parse(raw);
    } catch {
      data = {};
    }
  }

  if (!response.ok) {
    throw new Error(
      data.error ||
        data.message ||
        `Request failed (HTTP ${response.status})`
    );
  }

  return data;
}

export function globalSearch(query, limit = 5, signal) {
  return request(
    `/search?q=${encodeURIComponent(query)}&limit=${limit}`,
    { signal }
  );
}

export function getRecentSearches(limit = 8) {
  return request(`/search/recent?limit=${limit}`);
}

export function clearRecentSearches() {
  return request("/search/recent", {
    method: "DELETE",
  });
}
